/* ============================================================
   FILE: assets/component-price-range.js
   Add AFTER facets.js in theme.liquid:
     {{ 'component-price-range.js' | asset_url | script_tag }}
   ============================================================

   KEY DESIGN:
   - Slider inputs have NO name → never submitted to Shopify
   - Slider inputs have data-slider="true" → our JS targets them specifically
   - Dawn's PriceRange uses querySelectorAll('input') which picks up ALL inputs
     including our range inputs. We patch Dawn's class AFTER it is defined
     so its querySelectorAll only sees field__input elements.
   ============================================================ */

(function () {

  // Parse money strings like "3,699.00" or "3699" → float 3699
  function parseMoney(str) {
    if (!str) return NaN;
    return parseFloat(String(str).replace(/[^0-9.]/g, ''));
  }

  function initSlider(el) {
    if (el.dataset.sliderInit) return;
    el.dataset.sliderInit = '1';

    const sliderMin = el.querySelector('.price-range__input--min');
    const sliderMax = el.querySelector('.price-range__input--max');
    const progress  = el.querySelector('.price-range__progress');
    const textMin   = el.querySelector('.field__input[id*="GTE"]');
    const textMax   = el.querySelector('.field__input[id*="LTE"]');

    if (!sliderMin || !sliderMax || !textMin || !textMax) return;

    const rangeMax = parseFloat(sliderMax.getAttribute('max')) || 100;

    function updateProgress() {
      const low  = parseFloat(sliderMin.value) || 0;
      const high = parseFloat(sliderMax.value) || rangeMax;
      const leftPct  = (low  / rangeMax) * 100;
      const widthPct = ((high - low) / rangeMax) * 100;
      progress.style.left  = Math.max(0, leftPct)  + '%';
      progress.style.width = Math.max(0, widthPct) + '%';
    }

    function clamp() {
      let low  = parseFloat(sliderMin.value);
      let high = parseFloat(sliderMax.value);
      if (low >= high) {
        sliderMin.value = Math.max(0, high - 1);
      }
    }

    // Init slider positions from active filter text input values
    const initMin = parseMoney(textMin.value);
    const initMax = parseMoney(textMax.value);
    if (!isNaN(initMin) && initMin > 0)          sliderMin.value = initMin;
    if (!isNaN(initMax) && initMax < rangeMax)   sliderMax.value = initMax;
    updateProgress();

    // Slider dragged → write plain number into text input + update bar
    sliderMin.addEventListener('input', () => {
      clamp();
      textMin.value = Math.round(sliderMin.value);
      updateProgress();
    });

    sliderMax.addEventListener('input', () => {
      clamp();
      textMax.value = Math.round(sliderMax.value);
      updateProgress();
    });

    // Slider released → fire Dawn's 'change' handler so the filter form submits
    sliderMin.addEventListener('change', () => {
      textMin.dispatchEvent(new Event('change', { bubbles: true }));
    });

    sliderMax.addEventListener('change', () => {
      textMax.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // User types in text box → sync slider thumb position
    textMin.addEventListener('change', () => {
      const val = parseMoney(textMin.value);
      if (!isNaN(val)) { sliderMin.value = val; clamp(); updateProgress(); }
    });

    textMax.addEventListener('change', () => {
      const val = parseMoney(textMax.value);
      if (!isNaN(val)) { sliderMax.value = val; clamp(); updateProgress(); }
    });
  }

  /* ----------------------------------------------------------------
     Patch Dawn's PriceRange so its querySelectorAll('input') skips
     our slider inputs. We wait until the custom element is defined,
     then wrap its connectedCallback / constructor listeners.
  ---------------------------------------------------------------- */
  function patchDawnPriceRange() {
    // Dawn defines price-range via customElements.define('price-range', PriceRange)
    // After that, each price-range element in the DOM already has event listeners.
    // The safest approach: override querySelectorAll on each price-range instance
    // so Dawn only ever sees field__input elements.
    document.querySelectorAll('price-range.facets__price').forEach((el) => {
      if (el.dataset.patched) return;
      el.dataset.patched = '1';

      // Save original
      const original = el.querySelectorAll.bind(el);

      // Override: when Dawn calls querySelectorAll('input'), exclude slider inputs
      el.querySelectorAll = function (selector) {
        if (selector === 'input') {
          return original('input.field__input');
        }
        return original(selector);
      };
    });
  }

  function initAll() {
    patchDawnPriceRange();
    document.querySelectorAll('price-range.facets__price').forEach(initSlider);
  }

  // MutationObserver handles AJAX filter reloads
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
